/**
 * @returns true if plan is subscription based.
 */
export const isRecurringPlan = plan => Boolean(plan.pricing?.subscription);
//# sourceMappingURL=is-recurring-plan.js.map